import React, {FC, useEffect, useRef, useState} from "react";
import Card from "../../components/ui/Card";
import Modal from "../../components/ui/Modal";
import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import {FaPlusCircle, FaTrash} from "react-icons/fa";
import {AnimatePresence} from "framer-motion";
import useApi from "../../hooks/useApi";
import {ActionPlace, IAction, IFlow} from "../../types/ApiTypes";
import Autocomplete, {onAutocompleteChangeHandler} from "../../components/ui/Autocomplete";
import {toast} from "react-hot-toast";
import ActionList from "../../components/admin/ActionList";
import Loading from "../../components/Loading";
import axios from "axios";
import ActionModal from "../../components/admin/actions/ActionModal";
import handleToastError from "../../helpers/handleToastError";

const Actions: FC = () => {
    const mounted = useRef(false);

    const {fetchFlows,fetchActions,deleteAction} = useApi();

    const [confirmationModal, setConfirmationModal] = useState(false);
    const [actionToBeEdited, setActionToBeEdited] = useState<IAction>();
    const [editModalVisible, setEditModalVisible] = useState(false);

    const [actions, setActions] = useState<IAction[]>([]);
    const [flowsList, setFlowsList] = useState<{label: string, value: IFlow}[]>([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        mounted.current = true;
        return () => {mounted.current = false}
    },[])

    useEffect(() => {
        setLoading(true);
        fetchFlows().then(res => {
            if(mounted.current) {
                if(res) setFlowsList(res.flows.map(x => ({
                    label: x.name,
                    value: x
                })));
                setLoading(false);
            }
        })
    },[fetchFlows]);

    useEffect(() => {
        setLoading(true);
        fetchActions(ActionPlace.Details).then(res => {
            if(mounted.current) {
                if(res) setActions(res);
                setLoading(false);
            }
        })
    },[fetchActions])

    const onDeleteSelected = (id: number) => {
        setActionToBeEdited(actions.find(x => x.id === id));
        setConfirmationModal(true);
    }
    const onEditSelected = (id: number) => {
        setActionToBeEdited(actions.find(x => x.id === id));
        setEditModalVisible(true);
    }

    const deleteSelectedAction = async () => {
        if(!actionToBeEdited) return;
        await toast.promise(deleteAction(actionToBeEdited.id),{
            loading: 'Die Aktion wird gelöscht',
            success: () => {
                const actionName = actionToBeEdited.name;
                setActions(prev => prev.filter(x => x.id !== actionToBeEdited.id));
                setConfirmationModal(false);
                setActionToBeEdited(undefined);
                return <span>Aktion {actionName} wurde gelöscht</span>
            },
            error: (err) => handleToastError(err, "Die Aktion konnte nicht gelöscht werden")
        })
    }

    const onActionCreated = (action: IAction) => {
      setActions(prev => [...prev, action]);
    }

    const onActionEdited = (action: IAction) => {
        setActions(prev => [
          ...prev.filter(x => x.id !== action.id),
          action
        ]);
    }

    const onEditModalClosed = () => {
        setEditModalVisible(false);
        setActionToBeEdited(undefined);
    }

    return (
        <>
            <Card>
                {!loading && <ActionList actions={actions} deleteSelected={onDeleteSelected} editSelected={onEditSelected}/>}
                {loading && <div className='w-full p-4 bg-mainGray rounded-xl'><Loading small/></div>}
                <div className='flex justify-between items-center mt-3'>
                    <ActionModal flowsList={flowsList} onActionCreated={onActionCreated} onActionEdited={onActionEdited} action={actionToBeEdited} isOpen={editModalVisible} onClose={onEditModalClosed}/>
                </div>
            </Card>
            <AnimatePresence>
                {confirmationModal && (
                    <Modal isOpen={confirmationModal} onClose={() => {setConfirmationModal(false); setActionToBeEdited(undefined)}} title='Bereich löschen'>
                        Bist du sicher, dass du die Aktion "{actionToBeEdited?.name}" löschen möchtest?
                        <div className='flex justify-end gap-4'>
                            <Button onClick={deleteSelectedAction} type='button' className='bg-error-brighter hover:shadow-error-brighter/20'><FaTrash className='mr-2'/>Ja</Button>
                            <Button onClick={() => setConfirmationModal(false)} type='button'>Nein</Button>
                        </div>
                    </Modal>
                )}
            </AnimatePresence>
        </>
    );
};

export default Actions;